import { post } from '@/libs/http';
import { createApiMutationHook } from '@/hooks/use-api-mutation';
import type { GuestLoginReq, GuestLoginRes } from '@/types/api/user-auth/guest-login.d';
import { RSA_PUBLIC_KEY, type LoginStatusType } from '@/const/login';
import { getDeviceId, getDeviceInfo } from '@/libs/comeAppSDK';
import { Env } from '@/libs/env';
import { MD5 } from 'crypto-es';
import JSEncrypt from 'jsencrypt';

export interface CustomGuestLoginRes extends Omit<GuestLoginRes, 'loginStatus'> {
  loginStatus?: LoginStatusType;
}

export const postGuestLogin = ({
  params,
}: {
  params: GuestLoginReq;
}) => {
  return post<CustomGuestLoginRes>('/user/auth/v1/guest/login', params);
};

export const usePostGuestLogin = createApiMutationHook(postGuestLogin);

export const httpGuestLogin = async () => {
  const RegionCountryCodeMap = {
    india: {
      countryCode: 'IN',
    },
    brazil: {
      countryCode: 'BR',
    },
  };
  const deviceId = await getDeviceId();
  const deviceInfo = await getDeviceInfo();
  const countryCode = RegionCountryCodeMap[Env.REGION as keyof typeof RegionCountryCodeMap]?.countryCode || 'IN';
  const timeStamp = Math.floor(Date.now() / 1000);
  const rawStr = `${timeStamp}3${deviceId}`.toLowerCase();
  const hash = MD5(rawStr).toString();

  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(RSA_PUBLIC_KEY);
  const sign = encryptor.encrypt(hash) || '';
  return postGuestLogin({
    params: {
      timeStamp,
      deviceId: deviceId || '',
      deviceInfo: deviceInfo?.deviceBrand || '',
      countryCode: countryCode || '',
      signature: sign,
      distinctId: deviceId || '',
    },
  });
};
